import Vue from 'vue';
import app from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports';
import numeral from 'numeral';

// NO remover config. Es para chequear que toda la
// configuración esté definida al inicio.
import * as config from '@/config';

// Configurar Amplify
Amplify.configure(awsExports);

// Configurar Vue
Vue.config.productionTip = false;
const vueConfig = {
  router,
  vuetify,
  render: h => h(app)
}; 

// Configurar Numeral
numeral.register("locale", "es-cl", {
	delimiters: {
		thousands: ".",
		decimal: ","
	},
	currency: {
		symbol: "$",
	}
});
numeral.locale('es-cl');

// Inyectar aplicación
new Vue(vueConfig).$mount('#app');
